import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

import { KeywordRanking } from './keyword-ranking';
import { getViewAllPanelStyles } from './style/viewall-panel-style';
import { ActionBar } from './action-bar';
import { PanelHeader } from './panel-header';

export const KeywordGroupViewAllPanel = ({
  allData,
  selectedData,
  isOpen,
  onClose,
  i18n,
}) => {
  const activity = useContext(ActivityContext);
  const classes = useDefaultStyles(getViewAllPanelStyles);
  const [selection, setSelection] = useState(selectedData);
  const onSelectionChange = useCallback((data) => {
    setSelection(data);
  }, []);
  const onAdd = useCallback(() => {
    onClose(selection);
    // eslint-disable-next-line no-unused-expressions
    activity && activity.signal(`onAddSidePanelGroupDetailsGridKeywords - ${JSON.stringify({
      GridKeywords: selection,
    })}`);
  }, [onClose, selection, activity]);
  const onCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Panel
      isOpen={isOpen}
      onClose={onClose}
      i18n={i18n}
      panelClassName="side-panel-keyword-planner-view-all"
      title={<PanelHeader i18n={i18n} />}
      className={classes}
    >
      <FluentProvider theme={webLightTheme} className={classes.flexContainer} >
        <KeywordRanking
          allData={allData}
          selectedData={selectedData}
          onSelectChange={onSelectionChange}
        />
        <ActionBar
          onAdd={onAdd}
          onCancel={onCancel}
        />
      </FluentProvider>
    </Panel>
  );
};

KeywordGroupViewAllPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  allData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
